import React, { Component } from "react";
import { connect } from "react-redux";
import { getFormSyncErrors } from "redux-form";
import { Helmet } from "react-helmet";
import { createAccount } from "./../thunks/customerInfo";
import { CLOSE_ERROR_BOX } from "./../constants/actionTypes";
import { defaultAction } from "./../actions/defaultAction.js";
import SignUpForm from "./../components/account/forms/signUp.jsx";
import SpecificError from "./../components/popups/specificError.jsx";

class SignUp extends Component {
  createAccount = () => {
    const {
      signUpForm: { values },
      signUpErrors,
      signUpUser,
    } = this.props;

    if (signUpErrors && Object.keys(signUpErrors).length) {
      return;
    }

    const accountObj = {
      customer: {
        firstname: values.firstname.trim(),
        lastname: values.lastname.trim(),
        email: values.email.trim(),
        password: values.password.trim(),
        phone: values.phone.trim(),
        address: {
          street: values.address.trim(),
          city: values.city.trim(),
          state: values.state.trim(),
          postcode: values.zip.trim(),
        },
      },
    };

    if (values.address2) {
      accountObj.customer.address.street2 = values.address2.trim();
    }

    signUpUser(accountObj);
  };
  render() {
    const { config, popups, closeError } = this.props;
    return (
      <>
        <div className="registerbg">
          <Helmet>
            <title>Sign Up | {config.brand}</title>
            <link
              rel="canonical"
              href={
                window.location.origin.replace("beta", "www") +
                this.props.location.pathname
              }
            />
          </Helmet>
          <div className="Registration">
            <div className="Registration__form">
              <h1>Create Account</h1>
              <SignUpForm createAccount={this.createAccount} />
            </div>
            <div className="Registration__info">
              <p>CardCash Premier Seller Program</p>
              <h1>Earn More Profits</h1>
              <img
                alt="cardcash dollars"
                src="https://s3.amazonaws.com/new-cardcash-images/website/CC_dollars.png"
              />
              <p>Get Top Rates</p>
              <div className="Registration__divider" />
              <p>Dedicated Account Manager</p>
              <div className="Registration__divider" />
              <p>Receive Payments Fast</p>
            </div>
          </div>
        </div>
        <SpecificError
          notification={popups.get("errorMsg")}
          errorBox={popups.get("errorBox")}
          closeError={closeError}
          title={popups.get("title")}
        />
      </>
    );
  }
}

export default connect(
  (state) => ({
    config: state.config,
    customerInfo: state.customerInfo,
    popups: state.popups,
    signUpForm: state.form.signUp,
    signUpErrors: getFormSyncErrors("signUp")(state),
  }),
  (dispatch) => ({
    signUpUser: (profileData) => dispatch(createAccount(profileData)),
    closeError: () => dispatch(defaultAction(CLOSE_ERROR_BOX)),
  })
)(SignUp);
